import { render, staticRenderFns } from "./VideoCall.vue?vue&type=template&id=c91d4ae8"
import script from "./VideoCall.vue?vue&type=script&lang=js"
export * from "./VideoCall.vue?vue&type=script&lang=js"
import style0 from "./VideoCall.vue?vue&type=style&index=0&id=c91d4ae8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports